import * as ex from "excalibur";
import { Resources } from "../../Resources";
import { Player } from "../../player";
import { Grandpa } from "../../actors/characters/grandpa";

import { goToScene } from "../../main";
import HippyChick from "../../actors/characters/hippyChick";
import QuestionDialog from "../../ui/questionDialog";
import BeeClassMenu from "../beeClassMenu";
import { sendAlert } from "../../utils";
import BeeClass from "../beeClass";
import { playerState } from "../../state/stateManager";
import Professor from "../../actors/characters/professor";
import BeeClubCommerce from "../beeClubCommerce";

export default class BeeClub extends ex.Scene {
  constructor() {
    super();
    const player = new Player(18 * 16, 18 * 16);
    this.player = player;
    this.player.lastDir = "up";
    this.player.z = 5;
    this.hippyChick = new HippyChick({ x: 32 * 16, y: 12 * 16 }, "beeClub");
    this.hippyChick.z = 5;
    this.interacting = false;
    this.professor = new Professor({ x: 5 * 16, y: 6 * 16 });
    this.professor.z = 5;
  }
  onInitialize(engine) {
    Resources.BeeClubMap.addToScene(this);
    engine.add("beeClassMenu", BeeClassMenu);
    engine.add("beeClass", BeeClass);
    engine.add("beeClubCommerce", BeeClubCommerce);
    this.engine = engine;
    console.log("beeClub: adding player: ", this.player);
    this.player.lastDir = "up";
    // Resources.AppleCider.play(0.2);
    // Resources.AppleCider.loop = true;
    this.add(this.player);
    this.player.wearingVeil = false;
    this.player.cutScene = false;
    this.add(this.hippyChick);
    this.add(this.professor);
    this.hippyChick.scene = "beeClub";
    // this.player = Resources.HouseMap.getObjectsByName("player");

    this.camera.zoom = 1;
    // const map_bounds = ex.BoundingBox.fromDimension(
    //   Resources.TownMap.map.width * Resources.TownMap.map.tilewidth + 10,
    //   Resources.TownMap.map.height * Resources.TownMap.map.tileheight + 10,
    //   ex.Vector.Zero,
    //   Resources.TownMap.pos
    // );
    // this.camera.strategy.limitCameraBounds(map_bounds);

    this.door = new ex.Trigger({
      pos: new ex.Vector(26 * 16, 20 * 16 + 8),
      width: 90,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("town", { x: 39 * 16, y: 34 * 16, direction: "down" });
      },
    });
    this.add(this.door);

    this.classroomDoor = new ex.Trigger({
      pos: new ex.Vector(3 * 16, 15 * 16 + 8),
      width: 48,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        this.content = playerState.getContent();
        if (this.content.beeClasses.signedUp !== null) {
          Resources.Footsteps.stop();
          goToScene("beeClass", this.content.beeClasses.signedUp);
        }
        sendAlert("in the classroom");
      },
    });
    this.add(this.classroomDoor);

    this.deskTrigger = new ex.Trigger({
      pos: new ex.Vector(33 * 16, 12 * 16),
      width: 128,
      height: 100,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        // goToScene("town", { x: 39 * 16, y: 33 * 16, direction: "down" });
        this.player.cutScene = true;
        this.interacting = true;
        this.hippyChick.cutScene = true;
        this.greetingDialog = new QuestionDialog(
          [
            "Hi there, welcome to the Kozmania Bee Club, what can I do for you?",
          ],
          [
            `I'd like to sign up for a bee class.`,
            `I'd like to view the market`,
            `Nothing now thanks`,
          ],
          (reply, replyIndex) => {
            console.log("dialog ended");
            if (replyIndex == 0) {
              //open bee class menu

              goToScene("beeClassMenu");
            } else if (replyIndex == 1) {
              goToScene("beeClubCommerce");
            } else {
              //open market
              this.player.cutScene = false;
              this.interacting = false;
              this.hippyChick.cutScene = false;
            }
          },
          "hippyChick",
          "top"
        );
      },
    });
    this.add(this.deskTrigger);
  }
  onActivate(data) {
    if (data.data) {
      console.log("have location data: ", data.data);
      this.player.pos = new ex.Vector(data.data.x, data.data.y);
    }
    this.player.cutScene = false;
  }
  onPostUpdate() {
    //     if (this.engine.input.keyboard.wasPressed(ex.Keys.Space)) {
    //       if (this.computerCollision) {
    //         console.log("pressed space, should go");
    //         goToScene("onlineMarket");
    //       }
    //     }
    //   }
    if (this.interacting) {
      if (this.engine.input.keyboard.wasPressed(ex.Keys.Enter)) {
        this.greetingDialog.enterPress();
      }
      if (this.engine.input.keyboard.wasPressed(ex.Keys.Up)) {
        this.greetingDialog.iterateReply(true);
      }
      if (this.engine.input.keyboard.wasPressed(ex.Keys.Down)) {
        this.greetingDialog.iterateReply(false);
      }
      if (this.engine.input.keyboard.wasPressed(ex.Keys.X)) {
        this.interacting = false;
        this.player.cutScene = false;
        this.greetingDialog.destroy();
      }
    }
  }
}
